import { render, staticRenderFns } from "./mail-form.vue?vue&type=template&id=032fcb47&scoped=true&"
import script from "./mail-form.vue?vue&type=script&lang=js&"
export * from "./mail-form.vue?vue&type=script&lang=js&"
import style0 from "./mail-form.vue?vue&type=style&index=0&id=032fcb47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fcb47",
  null
  
)

export default component.exports